import { Conjunt } from "./conjunt.model";

export class Infant {
    dataNaixement: string;
    edat: number;
    sexe: string;
    tipusInfant: number;
}